import { Collapse } from '@mui/material';
import cn from 'classnames';
import { FC } from 'react';

import { CustomButton } from '../../../Button';

import styles from './CardDescription.module.sass';

interface ICardDescription {
  showMore: boolean;
  text: string;
  handleShowMore?: () => void;
}
const CardDescription: FC<ICardDescription> = ({
  showMore,
  text = '',
  handleShowMore,
}) => {
  return (
    <div className={styles.description}>
      <h1>Описание</h1>
      <div className={styles.collapse}>
        <Collapse in={showMore} collapsedSize={80}>
          <p className={styles.text}>{text}</p>
        </Collapse>
      </div>
      <CustomButton
        className={styles.buttonMore}
        variant="blue"
        onClick={handleShowMore}
      >
        Подробнее
      </CustomButton>
    </div>
  );
};

export default CardDescription;
